var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ProductSectionProducts',{attrs:{"products":_vm.productList,"total-items-count":_vm.totalItems,"is-loading":_vm.isLoading},on:{"loadMore":_vm.loadMore}})
}
var staticRenderFns = []

export { render, staticRenderFns }